import { OrderPaymentCardCreationDto } from '../dtos/order-payment-card.dto';
import { OrderPaymentCardCreation } from '../models/order-payment-card';

/**
 * To creation payment card dto.
 * @param {OrderPaymentCardCreation} model Payment card creation model.
 * @returns {OrderPaymentCardCreationDto}
 */
function toCreationDto(model) {
  return {
    payment_profile_id: model.paymentProfileId ?? undefined,
    group_admin_id: model.groupAdminId ?? undefined,
    card: model.card != null ? {
      type: model.card.type,
      token: model.card.token,
      billing_address: model.card.billingAddress,
      billing_zip: model.card.billingZip,
      name: model.card.name,
    } : undefined,
    is_save_card: model.card?.isSaveCard ?? undefined,
  };
}

export const orderPaymentCardMapper = {
  toCreationDto,
};
